import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getAdminWorkCalendarDataForProjectInTimeFrame = async (
  projectId,
  fromDate,
  toDate,
  activeEmployerInfo
) => {
  const apiPath = `workflow/admin-request/${projectId}/${fromDate}/${toDate}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
